import { useFlagMe451489EnableResponsiveLabelTruncationForTranslatedText } from '@generated/flags/ME-451489-enable-responsive-label-truncation-for-translated-text';
import { FS_UNMASK } from '@utils/fullstory';
import cx from 'classnames';
import { FC, HTMLProps } from 'react';

export const LABEL_MIN_HEIGHT = 16;

export const Label: FC<HTMLProps<HTMLLabelElement>> = (props) => {
  const enableResponsiveLabelTruncation =
    useFlagMe451489EnableResponsiveLabelTruncationForTranslatedText();

  return (
    <label
      css={{
        display: 'block',
        padding: 0,
        cursor: 'pointer',
        width: '100%',
        minHeight: LABEL_MIN_HEIGHT,
        ...(enableResponsiveLabelTruncation && {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }),
      }}
      {...props}
      data-label="field-label"
      className={cx(FS_UNMASK, props.className)}
    />
  );
};
